import React, { Component } from 'react'
import {Link} from 'react-router-dom'

import auth from '../Authentication/Auth'
import Header from '../../Components/Header/Header'
import createReactClass from 'create-react-class'

var MenuItem = createReactClass({
  handleClick: function(event) {
    this.props.onSelect(this.props.uid);
  },
  render: function() {
    var className = this.props.active ? 'active ' + this.props.uid : this.props.uid;

    return (

        <Link to={`/${this.props.uid}`} onClick={this.handleClick} className={className}>{this.props.name}</Link>

      )
  }
});

export default class Navigation extends Component {
  constructor(props) {
    super(props)

    this.state = {
        activeMenuItemUid: this.getRootPath(),
        menuItems: [
          {uid: 'orders', name:"Orders"},
          {uid: 'fuelfarm', name: "Fuel Farm"},
          {uid: 'fueltrucks', name: "Fuel Trucks"},
          {uid: 'reports', name: "Reports"},
          {uid: 'settings', name: "Settings"}
        ]
    };

    this.setActiveMenuItem = this.setActiveMenuItem.bind(this)
  }

  getRootPath(){
    let path = window.location.pathname.substring(1);
    return path.split('/')[0];
  }

  setActiveMenuItem(uid){
    this.setState({activeMenuItemUid: uid});
  }

  showMenuItem(menuItem){
    var shouldShow = true;

    return shouldShow;
  }

  renderMenuItem(menuItem){
    if(this.showMenuItem(menuItem)){
      return (
        <MenuItem
          active={(this.state.activeMenuItemUid === menuItem.uid)}
          key={menuItem.uid}
          onSelect={this.setActiveMenuItem}
          uid={menuItem.uid}
          name={menuItem.name}
        />
      )
    }
  }

  renderNavigation(){
    if(auth.loggedIn() && auth.hasFbo()){
      return(
        <aside>
          <nav>
            <ul>
              {this.state.menuItems.map((menuItem) => {
                return <li key={menuItem.uid} className={menuItem.uid}>{this.renderMenuItem(menuItem)}</li>
              })}
              <Link to={`/login`} className="login hide">Login</Link>
              <li className="current-user">
                { auth.getCurrentUser().firstName && auth.getCurrentUser().lastName ?
                  `${auth.getCurrentUser().firstName} ${auth.getCurrentUser().lastName}` :
                  "Current User"
                }
                <ul>
                  <li className="hide"><a href="#edit-profile">Edit Profile</a></li>
                  <li><Link to={`/logout`} className="logout">Logout</Link></li>
                </ul>
              </li>
            </ul>
          </nav>
        </aside>
      )
    }
  }

  renderMobileNavigation(){
    if(auth.loggedIn() && auth.hasFbo()){
      return(
        <div id="mobile-nav-toggle">
          <button className="hamburger hamburger--squeeze is-inactive" type="button">
            <span className="hamburger-box">
              <span className="hamburger-inner"></span>
            </span>
          </button>
        </div>
      )
    }
  }

  render() {
    return (
      <header id="app-header">
        {this.renderMobileNavigation()}
        <Header/>
        {this.renderNavigation()}
      </header>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Navigation/Navigation.js